<template>
  <div class="peopleindex">
    <div class="toolAndFilter">
      <div class="tool">
        <div style="display: inline-block;margin-right: 30px;">
          <el-button
            v-if="role.includes('add')"
            style="border-radius: 4px"
            size="medium"
            type="good"
            class="search"
            icon="el-icon-plus"
            @click="tianjiaHandler"
          >创建
          </el-button>
        </div>
      </div>
      <div class="filter">
        <div style="display: inline-block;max-width: 400px;flex-basis: 400px">
          <el-input
            v-model="query.name"
            size="medium"
            clearable
            placeholder="输入姓名/单位/部门/账号"
            @clear="sreachTableData"
            @keyup.native.13="sreachTableData"
          >
            <el-button
              slot="append"
              size="medium"
              type="good"
              icon="el-icon-search"
              @click="sreachTableData"
            >查询</el-button>
          </el-input>
        </div>
      </div>
    </div>
    <div class="body">
      <el-table
        :data="peopleTableData"
        height="100%"
        style="width: 100%"
      >
        <el-table-column
          show-overflow-tooltip
          type="index"
          label="#"
          width="50"
        >
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          prop="account"
          label="账号"
          width="120"
        >
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          prop="name"
          label="姓名"
          width="120"
        >
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          prop="company"
          label="单位"
        >
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          prop="department"
          label="部门"
          width="300"
        >
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          prop="roleName"
          label="角色"
          width="300"
        >
        </el-table-column>
        <el-table-column
          align="center"
          fixed="right"
          label="操作"
          width="330"
        >
          <template slot-scope="scope">
            <div style="display: flex;justify-content: flex-end">
              <el-button
                v-if="role.includes('reset')"
                size="mini"
                plain
                type="success"
                icon="el-icon-lock"
                @click="chongzhiHandler(scope.row)"
              >重置密码
              </el-button>
              <el-button
                v-if="role.includes('edit')"
                size="mini"
                plain
                type="primary"
                icon="el-icon-edit-outline"
                @click="XiuGaiHandler(scope.row)"
              >编辑
              </el-button>
              <el-button
                v-if="role.includes('none')&&scope.row.status==='1'"
                size="mini"
                plain
                type="info"
                icon="el-icon-remove-outline"
                @click="zhuxiaoHandler(scope.row,'0')"
              >注销
              </el-button>
              <el-button
                v-if="role.includes('none')&&scope.row.status!='1'"
                size="mini"
                plain
                type="warning"
                icon="el-icon-refresh-right"
                @click="zhuxiaoHandler(scope.row,'1')"
              >恢复
              </el-button>
              <el-button
                v-if="role.includes('del')"
                size="mini"
                plain
                type="danger"
                icon="el-icon-delete"
                @click="handlerRemoveClick(scope.row)"
              >
                删除
              </el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="tablePagination">
      <el-pagination
        background
        :current-page="query.pageNum"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="query.pageSize"
        layout="total, prev, pager, next, jumper"
        :total="query.totalRecord"
        @current-change="handleCurrentChange"
        @size-change="handleSizeChange"
      >
      </el-pagination>
    </div>
    <el-dialog
      class="addDialog"
      :title="formDialog.edit?'编辑':'创建'"
      :visible.sync="formDialog.formVisible"
      @close="cancelForm('form')"
    >
      <el-form
        ref="form"
        :model="form"
        :rules="rules"
        label-width="100px"
        size="small"
      >
        <div class="info">
          <el-row :gutter="20">
            <el-col :span="11">
              <el-form-item
                label="姓名"
                prop="name"
              >
                <el-input
                  v-model="form.name"
                  placeholder="请输入姓名"
                  onblur="this.value=this.value.replace(/\ +/g, '')"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="11">
              <el-form-item
                label="单位"
                prop="company"
              >
                <el-input
                  v-model="form.company"
                  placeholder="请输入单位"
                  onblur="this.value=this.value.replace(/\ +/g, '')"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="11">
              <el-form-item
                label="部门"
                prop="department"
              >
                <el-input
                  v-model="form.department"
                  placeholder="请输入部门"
                  onblur="this.value=this.value.replace(/\ +/g, '')"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="11">
              <el-form-item
                label="角色"
                prop="roleId"
              >
                <el-select
                  v-model="form.roleId"
                  placeholder="请选择角色"
                  style="width:100%;"
                >
                  <el-option
                    v-for="item in roles"
                    :key="item.roleId"
                    :label="item.roleName"
                    :value="item.roleId"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row
            v-show="!formDialog.edit"
            :gutter="20"
          >
            <el-col :span="11">
              <el-form-item
                label="账号"
                prop="account"
              >
                <el-input
                  v-model="form.account"
                  placeholder="请输入账号"
                  onblur="this.value=this.value.replace(/\ +/g, '')"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="11">
              <el-form-item
                label="密码"
                prop="password"
              >
                <el-input
                  v-model="form.password"
                  placeholder="请输入密码"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
      </el-form>
      <div
        slot="footer"
        class="dialog-footer"
      >
        <el-button @click="cancelForm('form')">取消</el-button>
        <el-button
          type="good"
          @click="submitForm('form')"
        >确定</el-button>
      </div>
    </el-dialog>

    <el-dialog
      class="addDialog"
      title="重置密码"
      :visible.sync="formDialog1.formVisible"
      @close="cancelPwdForm('form1')"
    >
      <el-form
        ref="form1"
        :model="form1"
        :rules="rules1"
        label-width="100px"
        size="small"
      >
        <div class="info">
          <el-row :gutter="20">
            <el-col :span="20">
              <el-form-item
                label="修改密码"
                prop="password"
              >
                <el-input
                  v-model="form1.password"
                  show-password
                  placeholder="请输入新密码"
                >
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
      </el-form>
      <div
        slot="footer"
        class="dialog-footer"
      >
        <el-button @click="cancelPwdForm('form1')">取消</el-button>
        <el-button
          type="good"
          @click="submitForm1('form1')"
        >确定</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
import {
  page,
  create,
  update,
  deleteById,
  getById,
  cancel,
  initPwd,
  getRoleList
} from '@/api/user/index'
// import {
//   getAreaTree
// } from '@/api/sys'
// import UploadImg from "./UploadImg";
import storage from 'store'
import {
  Button,
  Input,
  Table,
  TableColumn,
  Pagination,
  Dialog,
  Form,
  FormItem,
  Row, Message,
  Col,
  MessageBox,
  Select,
  Option
} from 'element-ui';
let CryptoJS = require('crypto-js');
export default {
  name: "FileTable",
  components: {
    // UploadImg,
    [Button.name]: Button,
    [Input.name]: Input,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Pagination.name]: Pagination,
    [Form.name]: Form,
    [FormItem.name]: FormItem,
    [Row.name]: Row,
    [Col.name]: Col,
    [Dialog.name]: Dialog,
    [Select.name]: Select,
    [Option.name]: Option
  },
  data () {
    return {
      peopleTableData: [],
      roles: [],
      role: {},
      query: {
        pageNum: 1,
        pageSize: 10,
        totalRecord: 0,
        name: "",
      },
      form: {
        account: '',
        name: "",
        password: "",
        company: "",
        department: "",
        roleId: ""
      },
      form1: {
        userId: '',
        password: "",
      },
      rules: {
        account: [{
          required: true,
          message: '请输入账户',
          trigger: 'blur'
        },
        {
          min: 1,
          max: 20,
          message: '长度在 1 到 20 个字符',
          trigger: 'blur'
        }
        ],
        name: [{
          required: true,
          message: '请输入姓名',
          trigger: 'blur'
        }],
        roleId: [{
          required: true,
          message: '请选择角色',
          trigger: 'blur'
        }],
        password: [{
          required: true,
          message: '请输入密码',
          trigger: 'blur'
        },
        {
          min: 8,
          max: 20,
          message: '长度在 8 到 20 个字符',
          trigger: 'blur'
        }],
      },
      rules1: {
        password: [{
          required: true,
          message: '请输入密码',
          trigger: 'blur'
        },
        {
          min: 8,
          max: 20,
          message: '长度在 8 到 20 个字符',
          trigger: 'blur'
        }],
      },
      formDialog: {
        loading: false,
        edit: false,
        formVisible: false
      },
      formDialog1: {
        loading: false,
        formVisible: false
      },

    }
  },
  created () {
    let role = storage.get('role');
    this.role = role['user']
    this.getList();
  },
  methods: {
    //加密方法
    aesEncrypt (content) {
      let key = CryptoJS.enc.Utf8.parse('lkjwmnnvflkdj85f');
      let srcs = CryptoJS.enc.Utf8.parse(content);
      let encrypted = CryptoJS.AES.encrypt(srcs, key, {
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7
      });
      return encrypted.toString();
    },
    handlerRemoveClick (data) {
      let that = this;
      MessageBox.confirm('此操作将永久删除该用户, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deleteById(
          data.userId
        ).then(res => {
          if (res.status == 1) {
            Message.success('删除成功');
            that.sreachTableData();
          }
        })
      })

    },
    zhuxiaoHandler (data, status) {
      let that = this;
      cancel({
        userId: data.userId,
        status: status
      }
      ).then(res => {
        if (res.status == 1) {
          Message.success('操作成功');
          that.getList();
        }
      })
    },
    submitForm (formName) {
      let that = this;
      that.$refs[formName].validate((valid) => {
        if (valid) {
          if (that.formDialog.edit) {
            update(that.form).then(res => {
              if (res.status == 1) {
                Message.success('修改成功');
                that.getList();
                that.formDialog.formVisible = false;
              }
            })
          } else {
            let j = JSON.parse(JSON.stringify(that.form))
            j.password = that.aesEncrypt(j.password);
            create(j).then(res => {
              if (res.status == 1) {
                Message.success('添加成功');
                that.formDialog.formVisible = false;
                that.sreachTableData();
              }
            })
          }
        }
      });
    },
    submitForm1 (formName) {
      let that = this;
      that.$refs[formName].validate((valid) => {
        if (valid) {
          let j = JSON.parse(JSON.stringify(that.form1))
          j.password = that.aesEncrypt(j.password);
          initPwd(j).then(res => {
            if (res.status == 1) {
              Message.success('修改成功');
              that.formDialog1.formVisible = false;
            }
          })
        }
      });
    },
    areaCodesChangeHandler (f, val) {
      if (val) {
        this.form[f] = val[val.length - 1];
      }
    },
    cancelForm (formName) {
      this.$refs[formName].resetFields();
      this.formDialog.formVisible = false;
    },
    cancelPwdForm (formName) {
      this.form1.userId = "";
      this.form1.password = "";
      this.$refs[formName].resetFields();
      this.formDialog1.formVisible = false;
    },
    getSex (idCard) {
      let sexStr = '';
      if (parseInt(idCard.slice(-2, -1)) % 2 == 1) {
        sexStr = '1';
      } else {
        sexStr = '2';
      }
      return sexStr;
    },
    censusRegisterCodeParse (code) {
      let i = [];
      if (!code) {
        return '';
      }
      if (code.length > 1) {
        i.push(code.substr(0, 2))
      }
      if (code.length > 3) {
        i.push(code.substr(0, 4))
      }
      if (code.length > 5) {
        i.push(code.substr(0, 6))
      }
      return i
    },
    currentResidenceCodeParse (code) {
      let i = [];
      if (!code) {
        return '';
      }
      if (code.length > 5) {
        i.push(code.substr(0, 6))
      }
      if (code.length > 8) {
        i.push(code.substr(0, 9))
      }
      if (code.length > 11) {
        i.push(code.substr(0, 12))
      }
      return i
    },
    /**
     * 从业人员添加
     */
    tianjiaHandler () {
      this.getRoleList();
      this.$nextTick(() => {
        this.formDialog.formVisible = true;
        this.formDialog.edit = false;
        this.form.roleId = "1584688855514";
      })
    },
    chongzhiHandler (data) {
      this.formDialog1.formVisible = true;
      this.form1.userId = data.userId
      this.formDialog.edit = false;
    },
    XiuGaiHandler (data) {
      this.getRoleList();
      let that = this;
      that.formDialog.formVisible = true;
      that.formDialog.edit = true;
      getById(data.userId
      ).then(res => {
        if (res.status == 1) {
          res.data.password = 'password';
          that.form = res.data;
        }
      })
    },
    getList () {
      let that = this;
      let f = JSON.parse(JSON.stringify(that.query));
      page(f).then(res => {
        if (res.status == 1) {
          that.peopleTableData = res.rows;
          that.query.totalRecord = res.total
        }
      })
    },
    sreachTableData () {
      this.query.pageNum = 1;
      this.getList();
    },
    handleCurrentChange (val) {
      this.query.pageNum = val;
      this.getList();
    },
    handleSizeChange (val) {
      this.query.pageSize = val;
      this.handleCurrentChange(1);
    },
    getRoleList () {
      this.roles = [];
      getRoleList().then(res => {
        if (res.status == 1) {
          this.roles = res.data;
        }
      })
    }
  }
}
</script>

<style scoped>
div {
  word-break: break-all;
}

.peopleindex {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.el-scrollbar ::v-deep .el-scrollbar__wrap {
  overflow-x: hidden;
}

.peopleindex .body {
  height: 0;
  flex-grow: 1;
}

.peoples {
  display: flex;
  flex-wrap: wrap;
}

.peoples .people {
  width: 390px;
  background-color: rgba(255, 255, 255, 100);
  color: rgba(16, 16, 16, 100);
  font-family: Roboto;
  border: 1px solid rgba(230, 230, 230, 100);
  padding: 16px;
  display: flex;
  color: rgba(16, 16, 16, 100);
  font-size: 14px;
  font-family: SourceHanSansSC-regular;
  line-height: 1.77em;
  margin: 0 16px 16px 0;
  flex-shrink: 0;
}

.peoples .people .headImg {
  width: 120px;
  height: 170px;
  position: relative;
  flex-shrink: 0;
  margin-right: 20px;
}

.peoples .people .headImg .tip {
  position: absolute;
  width: 100%;
  height: 24px;
  line-height: 24px;
  background-color: rgba(46, 136, 242, 100);
  text-align: center;
  bottom: 0;
  left: 0;
  color: rgba(255, 255, 255, 100);
  font-size: 14px;
  font-family: SourceHanSansSC-bold;
  font-weight: bold;
}

.people .tit {
  color: rgba(16, 16, 16, 100);
  font-size: 18px;
  font-family: SourceHanSansSC-bold;
  font-weight: bold;
}

.toolAndFilter {
  display: flex;
  justify-content: space-between;
  padding-bottom: 20px;
}

.toolAndFilter .tool {
  display: flex;
  width: 410px;
  flex-shrink: 0;
  align-items: center;
}

.toolAndFilter .filter {
  justify-content: flex-end;
  flex-grow: 1;
  display: flex;
  align-items: center;
}

.tablePagination {
  padding-top: 20px;
  display: flex;
  justify-content: flex-end;
}

.el-button {
  border-radius: 4px;
}

.el-form >>> .el-input__inner {
  border-radius: 4px;
}

.addDialog.el-dialog__wrapper >>> .el-dialog__body {
  display: block;
  overflow: auto;
  flex-grow: initial;
  flex-shrink: initial;
  flex-basis: initial;
}

.el-table .el-button + .el-button {
  margin-left: 10px;
  position: relative;
}

/* .el-table .el-button + .el-button::before {
  content: '';
  display: block;
  width: 0;
  height: 14px;
  border-right: 1px solid #999;
  position: absolute;
  left: -9px;
  top: 50%;
  transform: translateY(-50%);
} */

.el-table .el-button.delect {
  color: #ff5342;
}
.svgicon {
  width: 20px;
  height: 30px;
  fill: #bcbcbc;
  cursor: pointer;
  margin-right: 10px;
}
</style>